import type { Billing } from './billing-constants'

export function BillingToggle({ billing, onChange }: { billing: Billing; onChange: (b: Billing) => void }) {
  return (
    <div className="mb-6 flex justify-center">
      <div role="tablist" aria-label="Billing period" className="inline-flex rounded-full border border-gray-200 bg-white p-1 text-sm font-medium">
        <button
          type="button"
          role="tab"
          aria-selected={billing === 'monthly'}
          onClick={() => onChange('monthly')}
          className={[
            'rounded-full px-4 py-1.5 transition-colors',
            billing === 'monthly' ? 'bg-sky-500 text-white' : 'text-gray-600 hover:text-gray-900',
          ].join(' ')}
        >
          Monthly
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={billing === 'yearly'}
          onClick={() => onChange('yearly')}
          className={[
            'rounded-full px-4 py-1.5 transition-colors',
            billing === 'yearly' ? 'bg-sky-500 text-white' : 'text-gray-600 hover:text-gray-900',
          ].join(' ')}
        >
          Yearly <span className="ml-1 text-xs opacity-75">save ~15%</span>
        </button>
      </div>
    </div>
  )
}
